export default function WampCall($wamp) {
  return function (uri, args) {
    return $wamp.call(uri, args);
  }
}
